import React from "react";
import LineSeparator from "../../common/components/LineSeparator";

import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import { FaExclamationTriangle } from "react-icons/fa";

export default function LoginForm({
  handleSubmit,
  setEmail,
  setPassword,
  error,
  email,
  password,
}) {
  return (
    <Container className="m-auto">
      <Container style={{ maxWidth: "400px" }}>
        <h2>Login</h2>
        {error !== "" && (
          <Container className="my-4">
            <p style={{ color: "red" }}>
              {" "}
              <FaExclamationTriangle /> {error}
            </p>
          </Container>
        )}
        <Form className="py-3 mb-0" onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              autoComplete="username"
              value={email}
              onChange={(event) => {
                setEmail(event.target.value);
              }}
              style={{ border: "2px solid #f2f2f2", borderRadius: 10 }}
              placeholder=""
              required
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => {
                setPassword(event.target.value);
              }}
              style={{ border: "2px solid #f2f2f2", borderRadius: 10 }}
              placeholder=""
              required
            />
          </Form.Group>
          <Link className="text-dark text-end" to={""}>
            <p>password dimenticata?</p>
          </Link>
          <Button
            style={{ width: "100%", borderRadius: 20 }}
            variant="dark"
            type="submit"
          >
            LOGIN
          </Button>
          <LineSeparator text="O" marginY={40} marginX={10} color="#c5c5c5" />
          <Link to={"/register"}>
            <Button
              className="border-dark"
              style={{ width: "100%", borderRadius: 20 }}
              variant="white"
            >
              CREA UN ACCOUNT
            </Button>
          </Link>
        </Form>
      </Container>
    </Container>
  );
}
